module.exports = __webpack_public_path__ + "static/img/wgh.2020c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/wgh.jpg
// module id = MUpN
// module chunks = 1